// AboutUs.js
import React from 'react';
import firstImg from '../../assets/images/aboutUs/img1.png';
import secondImg from '../../assets/images/aboutUs/img2.png';

const AboutUs = () => {
  return (
    <section id="about-us" className="aboutUs">
      <div className="container flex row">
        <div className="aboutUs__leftContent flex column">
          <div className="flex row">
            <div className="aboutUs__card">
              <h2 className="titleSection">About us</h2>
            </div>
            <div className="aboutUs__card">
              <img src={firstImg} alt="" />
            </div>
          </div>
          <div className="aboutUs__bigCard">
            <div className="aboutUs__card">
              <img src={secondImg} alt="" />
            </div>
          </div>
        </div>
        <div className="aboutUs__rightContent flex column">
          <p className="aboutUs__textBold">
            Resanta is a globally recognized brand that constantly updates its product range with the latest technological innovations, offering customers cutting-edge solutions. We are dedicated to ensuring that our customers can always count on the reliability and efficiency of our equipment, which will help them succeed in their business endeavors. Our commitment to innovation and excellence has earned us the trust of businesses worldwide, with various industries relying on our advanced technologies to streamline operations, increase productivity, and stay competitive. With a strong emphasis on exceptional customer service, Resanta provides comprehensive support to its customers.
          </p>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
